import app from '@/app';

app.directive('focus', {
  mounted: (el, { value = true }) => {
    value && el.focus();
  },
});
